export { DEFAULT_PAGE_SIZE } from 'hooks/useSelectPanelField/constants';

export const FIELD_SECTION_KEY = 'field';

export const OTHER_SECTION_KEY = 'other';
